import { LineElement } from "./LineElements";

function setIndex<T>(array: T[], index: number, value: T): T[] {
  const clone = array.slice(0);
  clone[index] = value;
  return clone;
}

function minStartColAbove(lines: LineElement[], index: number): number {
  let min: number = lines[0].startCol;
  for (let i = 1; i < index; ++i) {
    if (lines[i].startCol < min) {
      min = lines[i].startCol;
    }
  }
  return min;
}

function minStartColBelow(lines: LineElement[], index: number): number {
  let min: number = lines[index + 1].startCol;
  for (let i = index + 2; i < lines.length; ++i) {
    if (lines[i].startCol < min) {
      min = lines[i].startCol;
    }
  }
  return min;
}

function widenLeft(lines: LineElement[]): LineElement[] {
  for (let i = 1; i < lines.length - 1; ++i) {
    const minAbove = minStartColAbove(lines, i);
    const minBelow = minStartColBelow(lines, i);
    const sCurr = lines[i].startCol;
    if (minAbove < sCurr && minBelow < sCurr) {
      const newStartCol = Math.max(minAbove, minBelow);
      return widenLeft(
        setIndex(lines, i, {
          startCol: newStartCol,
          width: lines[i].width + lines[i].startCol - newStartCol
        })
      );
    }
  }
  return lines;
}

function maxColAbove(lines: LineElement[], index: number): number {
  let max: number = lines[0].startCol + lines[0].width;
  for (let i = 1; i < index; ++i) {
    if (lines[i].startCol + lines[i].width > max) {
      max = lines[i].startCol + lines[i].width;
    }
  }
  return max;
}

function maxColBelow(lines: LineElement[], index: number): number {
  let max: number = lines[index + 1].startCol + lines[index + 1].width;
  for (let i = index + 2; i < lines.length; ++i) {
    if (lines[i].startCol + lines[i].width > max) {
      max = lines[i].startCol + lines[i].width;
    }
  }
  return max;
}

function widenRight(lines: LineElement[]): LineElement[] {
  for (let i = 1; i < lines.length - 1; ++i) {
    const maxAbove = maxColAbove(lines, i);
    const maxBelow = maxColBelow(lines, i);
    const sCurr = lines[i].startCol + lines[i].width;
    if (maxAbove > sCurr && maxBelow > sCurr) {
      return widenRight(
        setIndex(lines, i, {
          startCol: lines[i].startCol,
          width: Math.min(maxAbove, maxBelow) - lines[i].startCol
        })
      );
    }
  }
  return lines;
}

function fixBlank(lines: LineElement[]): LineElement[] {
  const result: LineElement[] = [];
  result.push(lines[0]);
  for (let i = 1; i < lines.length; ++i) {
    if (lines[i].width !== 0) {
      result.push(lines[i]);
    } else {
      result.push({
        startCol: result[i - 1].startCol,
        width: 0
      });
    }
  }
  return result;
}

export function convexHullLines(lines: LineElement[]): LineElement[] {
  if (lines.length === 0) {
    return lines;
  }

  return widenRight(widenLeft(fixBlank(lines)));
}
